import type { ComponentType } from "react";
import { FormControl } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getInputSizeMap } from "../sharedInputStyles";
import type { InputFieldSize } from "../sharedInputTypes";

// Remove MUI's size prop and add our own
type CustomFormControl = Omit<typeof FormControl, "size"> & {
  size?: InputFieldSize;
  minSize?: InputFieldSize;
};

// Added the `shouldForwardProp` option to the styled function.
// This tells MUI to not forward the size prop to the underlying DOM element, preventing the console warning.
export const SelectPopoverWrapper = styled(
  FormControl as ComponentType<CustomFormControl>,
  {
    shouldForwardProp: (prop) => prop !== "size" && prop !== "minSize",
  }
)<{ size: InputFieldSize; minSize?: InputFieldSize }>(
  ({ theme, size, minSize }) => ({
    width:
      typeof size === "number"
        ? `${size}px`
        : getInputSizeMap(theme)[size as InputFieldSize],
    ...(minSize && {
      minWidth:
        typeof minSize === "number"
          ? `${minSize}px`
          : getInputSizeMap(theme)[minSize as InputFieldSize],
    }),
    boxShadow: "none",

    // The Mui-focused class will be automatically added by FormControl
    "&.Mui-focused": {
      "& .MuiInputLabel-root": {
        color: theme.palette.primary.main,
      },
    },
  })
);
